<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3></h3>
<h1>Chapter Two</h1>
</div>
</div>
<blockquote>
<p class="first">
<i>“The most pure love I’ve ever experienced is from my dog. I could lose my show, never write another cookbook and go bankrupt and she would still think I was the most amazing human on the planet.” </i></p>
<p class="first" style="text-align: right;">
<i>Kate Richards, </i>Dog Tales Magazine</p>
</blockquote>
<h1>
	Chapter Two</h1>
<p class="sectiontop">
	“You didn’t have to miss one of Grace’s soccer games for this, did you, Pete?” Kate turned to the burly guy who had been filming her since they shot the pilot episode at a Queens sound stage four years ago.</p>
<p>
	“Grace didn’t complain when I told her this would help pay for that iTouch she wants for her birthday.” Pete winked at her and Kate was glad she had talked the <i>KidFit</i> honchos into kicking in overtime pay for the crew.</p>
<p>
	Kate wasn’t usually into big parties. She had celebrated her own thirty-fifth birthday at her sister’s dining room table in Bronxville eating a Betty Crocker yellow layer cake with chocolate frosting made by her eight-year-old niece. Kate planned on celebrating her dog’s first birthday with an afternoon at the park and a treat from Buttercup’s Paw-Tisserie.</p>
<p>
	But her publicist and default best friend Dana had seized the opportunity to film an extra segment for the show. Now, they had taken over the Chelsea dog park with the <i>KidFit</i> film crew and tables of food (both people and dog).</p>
<p>
	Not that Kate should complain. Since she had turned her life over to Dana, <i>KidFit</i> had been syndicated and her kids’ diet cookbook, <i>Mini-Munchies</i>, had made the <i>New York Times</i> bestseller list in both hardcover and paperback.</p>
<p>
	“Let’s get some footage of the kids playing with the dogs. You can add voiceovers about how playing with pets is a great way for kids to exercise, yada, yada.” Dana wiped a smudge of dirt off one of her Christian Louboutin wedge sandals that Kate knew for a fact cost over five hundred dollars.</p>
<p>
	“That’s actually a great idea.” As soon as Kate agreed, Pete zeroed his camera in on a little boy who was playing catch with a Black Lab puppy.</p>
<p>
	“Just try to pan the camera away from the woman in the leopard print skinny jeans—not a good look for her.” Dana looked beautiful even when she was acting ugly. Her cappuccino skin illuminated her regal cheekbones and high forehead. She was also one of those rare women who looked great in any shade of lipstick from bubble gum pink to traffic light red.</p>
<p>
	Kate cringed, but before she could interject, she heard a voice arguing with one of the cameramen.</p>
<p>
	“What d’ ya mean private party? This is a public dog run. You can’t take it over with your film crew!”</p>
<p>
	“We’re done at four. You can come back then,” said the cameraman, with the calm of someone who had dealings with irate New Yorkers on a regular basis.</p>
<p>
	“This is bullshit! Everywhere you go in this city, some jerk off is filming a reality show. I just want to exercise my dog. Is that really too much to ask?”</p>
<p>
	“This is going to ruin the rest of the footage. Someone needs to get this asshole out of here,” hissed Dana.</p>
<p>
	“I have a better idea.” Kate slid past Dana to the wrought iron gate.</p>
<p>
	“I’m really sorry we inconvenienced you. Why don’t you and your dog join the party?”</p>
<p>
	The man froze, a drip of sweat running down the crook of his nose, “You’re the woman from that kids’ workout show, right? My wife’s gonna go crazy when I tell her I met you!”</p>
<p>
	“I’m glad your wife enjoys the show. It’s my dog’s birthday today and …”</p>
<p>
	Kate lost her train of thought when she heard a deep growl resonate behind her. The transparent hairs on her arm stood up at the guttural sound. She spun around just in time to see a German Shepherd with pointy teeth bared, ready to jump on her Boston Terrier. By the looks of things, Sarah Jessica Barker had just stolen a rope toy from a dog that probably outweighed her by a good seventy pounds. Kate stood rooted to the spot, frozen in fear, while her dog growled at her opponent with the ferocity of an animal five times its size. The shepherd pounced.</p>
<p>
	Suddenly, a man flew across the dog park in two great leaps, grabbing the hose from the community water bowl on the way and blasting the snarling dog in the snout with a powerful surge of water. The mini geyser was harmless to the large dog, but it distracted him from trying to tear Sarah Jessica Barker to shreds. The man dropped the hose, soaking the German Shepherd and a few innocent animal and human bystanders in the process. Then, he plucked the Boston Terrier from the ground and carried her high above his head to the corner behind the cake table.</p>
<p>
	It wasn’t until her dog was safely ensconced behind the buttercream Louis Vuitton doggy satchel that Kate could make her feet move.</p>
<p>
	The Good Samaritan cradled the feisty pup in a football hold. “Calm down, you little trouble maker. You gotta learn when to pick your battles.”</p>
<p>
	For a split second Kate forgot all about her dog as she checked out the stranger, who was hot in an unexpected hero kind of way. In fact, he looked an awful lot like Seth Rogen in <i>The Green Hornet</i>.</p>
<p>
	“Oh my God! Is she hurt?” Kate focused her attention back on her dog, as soon as she reached the cake table.</p>
<p>
	The guy squatted down on his haunches and set Sarah Jessica Barker on her feet. The dog’s black and white fur was matted in flat clumps; her pink birthday bow wilted to the side. He ran his fingers through her coat, separating the fur to reveal strips of stark white skin. Thankfully there wasn’t any blood.</p>
<p>
	“I’m no vet, but I think she’s okay—just pissed off she didn’t win that fight.” He stood up and brushed wet fur coated hands on his jeans. His eyes drank in the bright afternoon sunlight and turned a translucent gray with whirls of steel blue in the center, just like the one perfect marble Kate and her sister used to fight over when they were little.</p>
<p>
	“Thanks for jumping in. I just froze. I literally couldn’t move my legs. That’s never happened to me before.” She could feel the latent adrenaline surging through her body while her heart beat in double time. Kate wasn’t used to having a man save her.</p>
<p>
	“Don’t worry about it. The water trick works every time.” He ran his hand through his brown hair, the waves breaking free from their prison of hair gel. Kate had always had a weakness for guys with curly hair, ever since she saw Tom Hanks in <i>Splash</i> at the Yonkers 6 Cineplex.</p>
<p>
	“Do you think I should take her to the vet to be on the safe side?” Kate scooped up Sarah Jessica Barker in her arms so she could double check for injuries, but her dog immediately jumped to the ground and ran towards a scrappy brown and white dog.</p>
<p>
	“I guess that answers your question. She looked fine as soon as she spotted my dog.”</p>
<p>
	“You’re Diesel’s owner?” Kate ran her tongue over her teeth, and said a silent prayer that she didn’t have poppy seeds stuck in them from that damn mini bagel she had just inhaled.</p>
<p>
	“According to my niece, our dogs are one step away from registering at Bed Bath &amp; Beyond.”</p>
<p>
	“Good for Sarah Jessica Barker. It’s hard to find a decent single man in this city.” Kate scoped out the ring finger on the stranger’s left hand and was relieved that it was completely naked.</p>
<p>
	Kate was torn away from drooling over the cute stranger when she spotted an over muscled twenty-something dragging his snarling German Shepard past them towards the exit.</p>
<p>
	“Hey! I asked you when you got here if your dog was aggressive and you said no!” Kate ran to the gate to catch them before they got away.</p>
<p>
	“Cujo seemed fine this morning when I picked him up.” The dog snapped his jaw wildly in the air and the guy had to pull back on the leash with such force, thick veins popped up on his forearms.</p>
<p>
	“Where’d you pick him up from? A dogfighting ring?”</p>
<p>
	“I borrowed him for the party.”</p>
<p>
	“What do you mean you borrowed him? And didn’t the name give you a clue?” Kate was practically blinded by the sun reflecting off the rhinestones on his skintight black tee shirt.</p>
<p>
	The man-boy shrugged his beefy shoulders. “Uh, no.” He stared back at Kate with a blank expression on his fake baked face, which was an unnatural shade of burnt sienna.</p>
<p>
	“Why would you borrow a dog for this party?” Kate knew there was no way the meathead wearing a trucker hat with New Jerzee graffitied on it was a <i>KidFit</i> fan.</p>
<p>
	“Ask your agent.” The guy pulled the dog through the metal gate and Kate watched as he struggled to get the seething beast across 23rd Street.</p>
<p>
	“Don’t you hate when people swear their dog isn’t aggressive right before it takes a chunk out of another dog?” But when Kate turned around she realized her hero wasn’t there to commiserate with her.</p>
<p>
	Kate would have to get down to the bottom of the mystery guest with Dana later. For now she just wanted to find the cute stranger and explain that she wasn’t as bitchy as she came across. Really.</p>
<p>
	Kate scanned the small park and spotted her Good Samaritan over by the food. He was close enough for Kate to hear him talking to a girl who looked like she was about nine or ten.</p>
<p>
	“Come on, Lauren. Time to go.” He rooted through the stack of leashes hanging from the gate and grabbed a thick blue one.</p>
<p>
	“We just got here!” The girl devoured a mini sesame seed bagel in two bites.</p>
<p>
	The man stepped towards the pack of dogs and called, “Diesel!”</p>
<p>
	“You can’t go yet. I didn’t get a chance to thank you.” As Kate got closer, she realized the little girl had an almost identical set of unnerving blue-gray eyes as the man. Kate’s heart sank as she realized he must have forgotten his wedding ring at home.</p>
<p>
	“No big deal.” The man shrugged and started to back away, but he ended up bumping into the buffet table so hard the mini-bagel tower collapsed.</p>
<p>
	“Sorry!” The man grabbed the bagels and started stacking them back up. “I’m such a klutz.”</p>
<p>
	“Don’t worry about it.” Kate reached for a pumpernickel bagel that had rolled near the veggie platter. In an attempt to grab the same bagel, the man ended up wrapping his hand around hers and Kate felt an actual flutter in her chest. He kept his hand there for an extra beat before busying himself with the bagel display.</p>
<p>
	“You could take him out for dinner,” the girl piped up. Kate was elated when she realized the cute stranger must be divorced; otherwise his daughter wouldn’t be trying to push him off on a date.</p>
<p>
	“Lauren!” The man gave the girl the stink eye. “That’s rude.” Kate stifled a laugh. It must be embarrassing to have your kid set you up.</p>
<p>
	“You guys could bring the dogs!” The girl pulled out her iPhone and asked Siri where the closest dog-friendly restaurant was. Siri’s computerized voice responded with a selection of fifteen neighborhood hotspots where dogs were welcome.</p>
<p>
	“Lauren! Kate probably has other plans.”</p>
<p>
	“Sadly, the only thing I have scheduled this weekend is my dog’s birthday party.”</p>
<p>
	“Hi, I’m Lauren. And this is Jack Horowitz.” The girl, who was right on the cusp of pre-teendom, reached out and wrapped Kate’s hand in a surprisingly firm grip for such a tiny person. She was wearing a red tee shirt that said</p>
<blockquote>
<p class="first" style="text-align: center;">
<i>Dear Math,</i></p>
<p class="first" style="text-align: center;">
<i>I am not your therapist.</i></p>
<p class="first" style="text-align: center;">
<i>Solve your own problems.</i></p>
</blockquote>
<p>
	“I’m Kate. Nice shirt.”</p>
<p>
	“Thanks. Uncle Jack got it for me.”</p>
<p>
	“I thought he was your dad.” Single and no kids. It kept getting better and better.</p>
<p>
	Lauren erupted in a fit of giggles. “OMG! I can’t wait to tell my dad you just said that.”</p>
<p>
	“Her dad is way tougher than me. He’s a Marine.” Jack finally looked up from the bagel display and a faint dimple that was probably a remnant of childhood appeared in his left cheek.</p>
<p>
	“You seem pretty tough to me. Breaking up that dog fight today.”</p>
<p>
	“It was nothing. Really.” The guy pinched his thumb and pointer finger between his lips and let loose a piercing whistle. Diesel bounded over to them in milliseconds and Jack leashed him up.</p>
<p>
	“It was something to me.” Kate locked eyes with him and smiled.</p>
<p>
	“We really need to get going.” Jack unlatched the gate.</p>
<p>
	“My uncle has to drop me off at Chelsea Piers for practice later. He can meet you by the M23 bus stop at 5 P.M.”</p>
<p>
	“The last thing I expected was to end up at dinner with a cute stranger tonight.” Maybe Dana had been right after all about throwing such a big party for Sarah Jessica Barker.</p>
<p>
	Jack pulled his dog and niece through the gate. “Trust me. This was the last thing I expected too.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap240840.vue?3ca45c32